import { useCallback } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { QueryKeys } from "@/constants/query.keys";

export const useInvalidateQueries = () => {
  const queryClient = useQueryClient();

  const invalidateQueries = useCallback(
    (queryKeys: QueryKeys[]) => {
      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey?.[0];
          if (typeof key !== "string") return false;
          if (query.isActive()) return false;

          return queryKeys.includes(key as QueryKeys);
        },
      });
    },
    [queryClient],
  );

  return { invalidateQueries };
};
